"use strict";
let secretNumber = Math.trunc(Math.random() * 20 + 1);
let score = 20;
let highScore = 0;
document.querySelector(".try").onsubmit = (e)=>{
    e.preventDefault();
    const guess = Number(document.querySelector(".guess").value);
    if (!guess) document.querySelector(".message").textContent = " ⛔️ NO NUMBER!";
    else if (guess > secretNumber) {
        if (score > 1) {
            document.querySelector(".message").textContent = "\uD83D\uDCC8 TOO HIGH!";
            score--;
            document.querySelector(".score").textContent = score;
        } else {
            document.querySelector(".message").textContent = "\uD83D\uDCA5 You lost the game!";
            document.querySelector(".score").textContent = 0;
            document.querySelector("body").style.backgroundColor = "rgb(219, 52, 52)";
            document.querySelector(".number").textContent = secretNumber;
        }
    } else if (guess < secretNumber) {
        if (score > 1) {
            document.querySelector(".message").textContent = "\uD83D\uDCC9 TOO LOW!";
            score--;
            document.querySelector(".score").textContent = score;
        } else {
            document.querySelector(".message").textContent = "\uD83D\uDCA5 You lost the game!";
            document.querySelector("body").style.backgroundColor = "rgb(219, 52, 52)";
            document.querySelector(".score").textContent = 0;
            document.querySelector(".number").textContent = secretNumber;
        }
    } else if (guess === secretNumber) {
        document.querySelector(".message").textContent = "CORRECT NUMBER \uD83C\uDF89";
        document.querySelector(".number").textContent = guess;
        if (score > highScore) highScore = score;
        else if (score < highScore) highScore;
        document.querySelector(".highscore").textContent = highScore;
        document.querySelector("body").style.backgroundColor = "#60b347";
        document.querySelector(".number").style.width = "30rem";
    }
};
document.querySelector(".again").addEventListener("click", ()=>{
    score = 20;
    document.querySelector(".score").textContent = score;
    secretNumber = Math.trunc(Math.random() * 20 + 1);
    // console.log(secretNumber);
    document.querySelector("body").style.backgroundColor = "#222";
    document.querySelector(".number").style.width = "15rem";
    document.querySelector(".message").textContent = "Start guessing...";
    document.querySelector(".number").textContent = "?";
    document.querySelector(".guess").value = null;
});

//# sourceMappingURL=index.8ff92375.js.map
